import * as types from "../constants";

export function setIntroJs(value) {
  return {
    type: types.SET_ENABLED_INTROJS,
    payload: value
  }
}
